import OnlinePlusLogin from 'gcs-common/components/OnlinePlusLogin/OnlinePlusLogin';
import OnlinePlusWebWrapper from '../OnlinePlusWebWrapper';

const OnlinePlusLoginWeb = () => {
  return (
    <OnlinePlusWebWrapper>
      <OnlinePlusLogin />
    </OnlinePlusWebWrapper>
  );
};

export default OnlinePlusLoginWeb;
